export function isKnownBrowser(): boolean {
  for (const inAppBrowser of ['instagram']) {
    if (navigator.userAgent.toLowerCase().includes(inAppBrowser)) {
      return false;
    }
  }
  for (const browser of ['safari', 'chrome', 'opera', 'firefox', 'edge']) {
    if (navigator.userAgent.toLowerCase().includes(browser)) {
      return true;
    }
  }
  return false;
}
